<template>
    <div class="single_content">
        <v-loading loader='setSingleData' class="loader" v-if="$loading.isLoading('setSingleData')">
            <template slot='spinner'>
                <div class="loader">
                    <img src="../../../../assets/img/grid_loader.svg"/>
                </div>
            </template>
        </v-loading>
        <div class="single" v-if="!$loading.isLoading('setSingleData')">
            <aside>
    			<div class="top">
    				<div class="border"></div>
    				<upload-avatar :item="data" entities="users" field="avatar"></upload-avatar>
    			</div>

                <div class="contain">

				<div class="name">
					<h2>{{ data.first_name }} {{ data.last_name }}</h2>
				</div>

				<div class="about">
					<v-subheader>A propos</v-subheader>

                    <div class="field" data-group="1">
                        <div class="label">Prénom :</div>
                        <div class="value">
                            <single-field :model="data.first_name" ref="first_name" @validate="updateField('first_name', $event)" :hide_eye="true"></single-field>
                        </div>
                    </div>

                    <div class="field" data-group="1">
                        <div class="label">Nom :</div>
                        <div class="value">
                            <single-field :model="data.last_name" ref="last_name" @validate="updateField('last_name', $event)" :hide_eye="true"></single-field>
                        </div>
                    </div>

                    <div class="field" data-group="1">
                        <div class="label">Email :</div>
                        <div class="value">
                            <single-field :model="data.email" ref="email" @validate="updateField('email', $event)" :hide_eye="true"></single-field>
                        </div>
                    </div>

                    <div class="field" data-group="0">
                        <div class="label">Niveau :</div>
                        <div class="value">
							<single-field :model="data.role_id ? data.role_id: ''" ref="role_id" type="select" :options="Roles" optionText="label" optionValue="value" @validate="updateField('role_id', $event)" :hide_eye="true"></single-field>
						</div>
                    </div>

                </div>
			</div>
		</aside>

		<div class="tab">
			<v-tabs slider-color="primary" :show-arrows="true">
				<v-tab ripple :to="{ name: 'admin-single-user-general' }">Mot de passe</v-tab>
			</v-tabs>
			<div class="router_view">
				<router-view />
			</div>
		</div>
	   </div>
    </div>
</template>

<script>
    import UploadAvatar from '../../../../components/avatar/UploadAvatar'
    import SingleField  from '../../../../components/SingleField'
    import {Roles}          from '../../../../config/enum/Roles'

    export default {
    	components: {
            UploadAvatar, SingleField
        },

    	data() {
    		return {
                Roles
    		}
    	},

    	computed: {
    		data() {
    			return this.$store.state.single.data
    		}
    	},

    	methods: {
            getDataFromApi() {
                this.$loading.startLoading('setSingleData')
    			this.axios.get(`/api/users/${this.$route.params.id}`)
    				.then(res   => {
                        this.$store.dispatch('setSingleData', { data: res.data })
                        this.$loading.endLoading('setSingleData')
                    })
                    .catch(err  => console.log(err.response.data))

    		},

    		updateField(key, value, resource = 'users') {
    			let model = {};
    			model[key] = value;

    			this.axios.put(`/api/${resource}/${this.$route.params.id}`, model)
    				.then(res   => this.$store.dispatch('updateSingleData', { key, value }))
    				.catch(err  => this.$refs[key].setError(error.response.data.errors[key][0]))
    		}
    	},

    	created() {
    		this.getDataFromApi()
    	}
    }
</script>

<style lang="stylus" scoped>
    // aside {
    //     position:relative
    // }
    //
    // div.about {
    //   flex-grow: 1
    //
    //   .avatar {
    //     margin-right:10px
    //   }
    // }
    // div.single-actions {
    //   padding: 0px
    //   position: absolute
    //   bottom: 20px
    //
    //   button:first-child {
    //     float:left
    //   }
    //
    //   & > .flex {
    //     margin:20px
    //     div.group-actions {
    //       float:right
    //     }
    //   }
    //
    //
    // }

</style>



// WEBPACK FOOTER //
// src/views/admin/users/single/Single.vue